import React from "react";
import * as Styled from "./styles";
import UserImage from "../UserImage";
import { TextView } from "@components";
import { colors } from "../../utils";
import { useNavigate } from "react-router-dom";
import { resetFolders } from "../../redux/reducers/gallery";
import { useDispatch } from "react-redux";

export default function UserItem({
  item,
  setSearchText,
  setModalOpen = null,
  setOnLeave = null,
  wheelInformation = null,
  prevIndexRef = null,
  setShowResults = null,
  handleNavigate = null,
}) {
  const { first_name, last_name, user_id, profile_image, profession ,username} = item;
  const nav = useNavigate();
  const dispatch = useDispatch();

  const itemVariants = {
    initial: { opacity: 0, y: 10 },
    animate: { opacity: 1, y: 0 },
    hover: {
      scale: 1.02,
      boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      transition: {
        duration: 0.2,
        ease: "easeInOut",
      },
    },
    tap: {
      scale: 0.98,
      transition: {
        duration: 0.1,
      },
    },
  };

  const handleUserClick = () => {
    setShowResults(false);

    // Call handleNavigate if it exists
    if (handleNavigate) {
      handleNavigate();
      return;
    }

    if (setOnLeave && setModalOpen) {
      const currentIndex = wheelInformation?.currentIndex;

      if (prevIndexRef.current !== currentIndex) {
        setOnLeave(() => () => {
          setSearchText("");
          dispatch(resetFolders());
          nav(`/gallery/${user_id}`);
        });
        setModalOpen(true);
        prevIndexRef.current = currentIndex;
      } else {
        setSearchText("");
        dispatch(resetFolders());
        nav(`/gallery/${user_id}`);
      }
    } else {
      setSearchText("");
      dispatch(resetFolders());
      nav(`/gallery/${user_id}`);
    }
  };
  

  return (
    <Styled.SearchItem
      onClick={handleUserClick}
      variants={itemVariants}
      initial="initial"
      animate="animate"
      whileHover="hover"
      whileTap="tap"
    >
      <div style={{ minWidth: 50, flexShrink: 0 }}>
        <UserImage image={profile_image} size={49} />
      </div>
      <Styled.SearchItemDetails>
        <TextView variant="subtitle" style={{ fontSize: 14 }}>
          {username}
        </TextView>

          <TextView color={colors.lightGrey}>{first_name} {last_name}</TextView>
    
      </Styled.SearchItemDetails>
    </Styled.SearchItem>
  );
}
